import { render } from "./ServiceCarouselCard.vue?vue&type=template&id=6f9d0a5d&scoped=true"
import script from "./ServiceCarouselCard.vue?vue&type=script&lang=js"
export * from "./ServiceCarouselCard.vue?vue&type=script&lang=js"

import "./ServiceCarouselCard.vue?vue&type=style&index=0&id=6f9d0a5d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f9d0a5d"]])

export default __exports__